import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {
  StyledDeleteModal,
  StyledDeleteModalSpace,
  StyledDeleteModalLogoContainer,
} from './StyledDeleteModal';
import TrashIcon from '../../icons/TrashIcon';

const DeleteModal = ({
  children,
  description,
  loading = false,
  open,
  title,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'invoices']);

  return (
    <StyledDeleteModal
      open={open}
      okText={t('delete')}
      loading={loading}
      cancelButtonProps={{size: 'middle'}}
      okButtonProps={{loading, size: 'middle', type: 'primary'}}
      width={400}
      title={title}
      {...rest}
    >
      <StyledDeleteModalSpace
        align='center'
        direction='vertical'
        size={10}
      >
        <StyledDeleteModalLogoContainer>
          <TrashIcon />
        </StyledDeleteModalLogoContainer>
        {description && <p>{description}</p>}
        {children}
      </StyledDeleteModalSpace>
    </StyledDeleteModal>
  );
}

DeleteModal.propTypes = {
  loading: PropTypes.bool,
  open: PropTypes.bool.isRequired,
}

export default DeleteModal;
